<div
  role="group"
  [attr.aria-label]="ariaLabel()"
  class="flex gap-2 sm:gap-3"
  (focusout)="onFocusOut($event)">
  @for (field of fields(); track field.index) {
    <input
      #field
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      class="h-12 w-11 rounded-md border bg-white text-center text-xl font-bold focus:ring-1 focus:outline-none disabled:cursor-not-allowed disabled:opacity-60 sm:h-14 sm:w-14"
      [class]="fieldClass()"
      [attr.aria-label]="field.label"
      [attr.aria-invalid]="invalid()"
      [value]="field.digit"
      [disabled]="disabled()"
      (input)="onInput($event, field.index)"
      (paste)="onPaste($event, field.index)"
      (keydown.backspace)="onBackspace($event, field.index)"
      (focus)="selectContent($event)" />
  }
</div>
